import { GenerateRepairShopMedia } from "../../../../model/GenerateRepairShopMedia";
import { RepairShopOptionInfo } from "../../../../model/RepairShop/Options";

export interface RepairshopEditRequestBody {
  displayName: string;
  repairShopName?: string;
  managerName: string;
  tel: string;
  rePass?: string;
  openingDay: string[];
  holidayWorkable: string[];
  regionDepth1: string;
  regionDepth2: string;
  regionDepth3: string;
  zipCode: number;
  country: string;
  detail: string;
  street: string;
  zibun: string;
  receivedOneHour: boolean;
  liftCount?: number;
  employeeCount?: number;
  foreignWAHandleable: boolean;
  domesticWAHandleable: boolean;
  rFTHandleable: boolean;
  lightRepairHandleable: boolean;
  foreignCarHandleable: boolean;
  waitingRoomExistence: boolean;
  twentyInchTireHandleable: boolean;
  moreDetail?: string;
  introduction?: string;
  businessMediaId: number;
  repairShopMedias: GenerateRepairShopMedia[];
  repairShopAId: string;
  managerEmail: string;
  managerPhone: string;
  marketingMessageReceivable?: boolean;
  marketingEmailReceivable?: boolean;
  marketingPushReceivable?: boolean;
  optionalTermsIds: number[];
  password: string;
  authTokenId: string;
  accessToken: string;
  subManagerPhoneList: string[];
  domesticEngineOilExchangeable: boolean;
  domesticBatteryExchangeable: boolean;
  foreignEngineOilExchangeable: boolean;
  foreignBatteryExchangeable: boolean;
  maximumWeekdayVehicleCount: number;
  maximumWeekendVehicleCount: number;
  bongoAcceptable: boolean;
  porterHighTopAcceptable: boolean;
  porterLowTopAcceptable: boolean;
  truckAcceptable?: boolean;

  /**
   * 매장 서비스 정보
   * @TODO 추 후  위에 중복되는 속성 제거하기
   */
  repairShopOption: RepairShopOptionInfo;

  [index: string]: any;
}
export const UserManagementQueryKeys = {
  GET_INFO: "get_info",
};
export interface ResetPassRequest {
  password: string;
  newPassword: string;
}
